<template>
    <div id="news" class="page-wrapper" style="height:900px; background:#F5F7FA;">
        <div class="page-content" style="padding-top:90px; position:relative; " >
            <div class="title" style="margin-bottom:80px;">华翊动态</div>
            <div class="control">
                <div class="btn" @click="handleScroll('left')"><i class="ri-arrow-left-s-line" style="font-size:24px;"></i></div>
                <div class="btn" @click="handleScroll('right')"><i class="ri-arrow-right-s-line" style="font-size:24px;"></i></div>
            </div>
            <div class="scroller-container">
                
                <div class="scroller-viewBox" :style="{ transform:`translateX( ${scrollIndex * 100}%)` }">
                    <div
                        v-for="(item, index) in list"
                        :key="index"
                        class="card-wrapper"
                        @click="$router.push(`/about/news-detail?id=${item.contentId}`)"
                    >
                        <div class="card">
                            <div class="card-image" :style="{ backgroundImage:`url(${getFullPathMethod(item.coverImagePath)})` }"></div>
                            <div class="card-content">
                                <div class="card-title">{{ item.tittle }}</div>
                                <div class="card-desc">{{  htmlToStringMethod(item.content) }}</div>
                                <div class="card-extra">
                                    <div style="color:#99A0AE; font-size:16px; ">{{  item.createTime }}</div>
                                    <div class="tag">{{ item.category }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="line-height:20px; color:#335CFF; margin:40px 0; text-align:center; " ><span style="padding:14px; cursor:pointer;" @click="$router.push('/about/news')">更多资讯</span></div>
        </div>
    </div>

</template>

<script>
    import { markAction, getFullPath, getContentList } from '@/api/global.js';
    import { Message } from 'element-ui';
    let lock = false;
    let splitNum = 0;
    const imgReg = /<img.*?>/g;
    const videoReg = /<video.*?(?:>|\/>)/gi;
    function htmlToString(html) {
        var tempDiv = document.createElement("div");
        html = html.replace(imgReg, '');
        html = html.replace(videoReg, '');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || "";
    }
    export default {
        data(){
            return {
                scrollIndex:0,
                timer:null,
                list:[]
            }
        },
        methods:{
            handleScroll(direc){
                // 判断是左侧滚动到头
                if ( !lock ) {
                    lock = true;
                    this.timer = setTimeout(()=>{
                        lock = false;
                    }, 500)
                    if ( this.scrollIndex === 0 && direc === 'left'  ) {
                        Message.info('左侧没有内容了');
                        return;
                    }
                    if ( ( this.list.length <=3 || splitNum === Math.abs(this.scrollIndex - 1 )) && direc === 'right'  ) {
                        Message.info('右侧没有内容了');
                        return;
                    }
                    // 判断是右侧滚动到底
                    if ( direc === 'left' ) {
                        ++this.scrollIndex;
                    } else {
                        --this.scrollIndex;
                    }
                }
            },
            getFullPathMethod(path){
                return getFullPath(path);
            },
            htmlToStringMethod(url){
                return htmlToString(url);
            },
            fetchContentList(){
                getContentList({ page:1, pageSize:20, contentType:'动态' })
                .then(res=>{
                    if ( res.data.code === 200 ) {
                        splitNum = Math.ceil(res.data.data.length / 3);
                        this.list = res.data.data;
                    }
                })
            }
        },
        mounted(){
            this.fetchContentList();
        }
    }
</script>
<style scoped>
    .scroller-container {
        width:100%;
        position:relative;
        overflow:hidden;
    }
    .control {
        position:absolute;
        right:24px;
        top:170px;
    }  
    .control .btn {
        display:inline-block;
        width:48px;
        height:48px;
        line-height:48px;
        text-align:center;
        border-radius:50%;
        border: 1px solid#cacfd8;
        margin-right:32px;
        cursor: pointer;
    }
    .control .btn:hover {
        background-color:#e5e5e7;
    }
    .control .btn:last-child {
        margin-right:0;
    }
    .scroller-viewBox {
        width:100%;
        transition:all 0.8s;
        white-space:nowrap;
    }
    .scroller-viewBox .card-wrapper {
        cursor: pointer;
        transition:none;
    }
    .scroller-viewBox .card-wrapper:hover {
        box-shadow:0 0 50px rgba(0,0,0,.05);
    }
    .scroller-viewBox .card-wrapper:nth-child(3n+ 1) {
        margin-left: 2px;;
    }
</style>